module.exports = __webpack_public_path__ + "flaticon.b30b685a35715bb754f8.svg";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/multi-sports/flaticon.svg
// module id = ../../../../../src/scss/multi-sports/flaticon.svg
// module chunks = styles